module.exports = __webpack_public_path__ + "assets/img/addressText.b80e78ef.png";